const messages = {
  availPoints: "Saadaolevad punktid",
  awaitingPoints: "Ootel punktid",
  board: {
    title: "Töölaud",
    title2: "Kampaania tulemuslikkus {year}",
    headline1: "Teie kampaaniad ja punktid ühe pilguga",
    headline2: "Teenige punkte rehviostude eest.",
    pointsBalanceToDate: "PUNKTIDE SALDO KUUPÄEVA SEISUGA",
    availPoints: "Saadaolevad punktid",
    awaitingPoints: "Ootel punktid",
    yourRealisation: "TEIE TULEMUSED",
    yourEngagement: "Teie aastane eesmärk: <b>{tyres} rehvi</b>",
    yourPoints: "TEIE PUNKTID",
    yourRetailPurchase: "TEIE OSTD ÜKSIKASJALIKULT",
    yourRetailPurchaseCCS: "TEIE MÜÜGID ÜKSIKASJALIKULT",
    pointsByPurchase: "ostudest teenitud punktid",
    pointsByBoosters: "boosteritest teenitud punktid",
    pointsByBSPurchase: "Bridgestone'ilt ostudest teenitud punktid",
    pointsByBSPurchaseCCS: "Bridgestone rehvide müügist teenitud punktid",
    remaining: "Järelejäänud rehvid",
    yourGoal: "Eesmärgi täitmise edenemine",
    unit: "rehvid",
    buttons: {
      learnMore: "Lisateave oma punktide kohta",
      learnMoreAboutMechanism: "Loe mehhanismi kohta rohkem",
    },
    charts: {
      byBrand: "Brändi järgi",
      bySize: "Veljemõõdu<br/>järgi",
    },
    exploreResults: "Tutvu oma tulemustega",
    tyreLimitInfo:
      "Iga Boosteri kampaaniaperioodi jaoks on nõutav vähemalt 50 Bridgestone'i ja/või Firestone'i rehvi sell-out maht.",
  },
  charts: {
    byBrand: "Brändi järgi",
    bySize: "veljemõõdu järgi",
  },

  dashboard: {
    dashboardTitle: "Teie eelised",
    dashboardBox: {
      title: "Punktide saldo",
      description: "Teie praegune turunduspunktide arv",
      availPoints: "Saadaolevad punktid",
      awaitingPoints: "Ootel punktid",
      lastUpdate: "Viimane uuendus",
      button: "Loe lähemalt",
      points: "punktid",
    },
  },
  soldTyres: "MÜÜDUD REHVID",
  receivedPoints: "TEENITUD PUNKTID",
  boosterCCS: {
    personalInfo: "Isikuandmed",
    csNumberTitle: "Palun sisestage osalevate kontode number(numbrid)",
    tyresTitle: "Palun sisestage müüdud rehvide arv",
    minTyresInfo:
      "Nõutav miinimum on {tyres} Bridgestone/Firestone rehvi. Tasu arvestatakse ainult Bridgestone rehvidele.",
    tyresAmount: "Rehvide arv",
    filesTitle: "Palun laadige üles müügitõendid",
    filesDescription:
      "Märkus: arvesse lähevad ainult müügid, kus on märgitud rehvi veljemõõt.",
    addAnotherFile: "Lisa dokument",
    file: "Laadi dokument üles",
    formatInfo:
      "Toetatud failivormingud: xlsx, jpeg ja pdf. Maksimaalne failisuurus: 8 MB",
    confrimationMessage:
      "<b>Aitäh osalemast!</b> <br/>Teie taotlus on vastu võetud ja edastatud Bridgestone'i tiimile kinnitamiseks.<br/>Saate e-kirja teel teavituse oma osalemise tulemuste kohta Booster CCS kampaanias.<br/>Kohtumiseni peagi Bridgestone Plusis!",
  },
  sharePointModal: {
    header: "Jaga punkte",
    forShare: "Punktid, mida jagate",
    title: "Pealkiri",
  },
  notFoundFile: "Faili pole valitud",
  chooseFile: "Vali fail",
};

export default {
  messages,
};
